<template>
  <div class="table-container">
    <el-table :data="data" v-loading="loading" style="width: 100%" border>
      <el-table-column prop="id" :label="$t('MemberRegistrationReview.serialNumber')" width="80" align="center"/>
      
      <el-table-column prop="contactName" :label="$t('MemberRegistrationReview.contactName')" width="120" align="center"/>
      
      <el-table-column prop="storeName" :label="$t('MemberRegistrationReview.storeName')" min-width="150" show-overflow-tooltip/>
      
      <el-table-column prop="email" :label="$t('MemberRegistrationReview.email')" min-width="180" show-overflow-tooltip/>
      
      <el-table-column prop="tel" :label="$t('MemberRegistrationReview.tel')" width="130" align="center"/>
      
      <el-table-column prop="country" :label="$t('MemberRegistrationReview.country')" width="100" align="center"/>
      
      <el-table-column prop="applicantStatus" :label="$t('MemberRegistrationReview.applicantStatus')" width="120" align="center">
        <template #default="scope">
          <el-tag :type="getStatusType(scope.row.applicantStatus)">
            {{ scope.row.statusText }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column prop="applyTime" :label="$t('MemberRegistrationReview.applyTime')" width="180" align="center">
        <template #default="scope">
          {{ formatDateTime(scope.row.applyTime) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="reviewer" :label="$t('MemberRegistrationReview.reviewer')" width="100" align="center">
        <template #default="scope">
          {{ scope.row.reviewer || '-' }}
        </template>
      </el-table-column>
      
      <el-table-column :label="$t('MemberRegistrationReview.operation')" width="200" align="center" fixed="right">
        <template #default="scope">
          <div v-if="scope.row.applicantStatus === 'pending'" class="action-buttons">
            <el-button 
              @click="handleApprove(scope.row)" 
              type="success" 
              size="small"
              :loading="scope.row.approving"
              class="approve-btn">
              <el-icon><Check /></el-icon>
              {{ $t('MemberRegistrationReview.approve') }}
            </el-button>
            <el-button 
              @click="handleReject(scope.row)" 
              type="danger" 
              size="small"
              :loading="scope.row.rejecting"
              class="reject-btn">
              <el-icon><Close /></el-icon>
              {{ $t('MemberRegistrationReview.reject') }}
            </el-button>
          </div>
          
          <div v-else class="status-display">
            <el-tag 
              :type="scope.row.applicantStatus === 'approved' ? 'success' : 'danger'" 
              size="small"
              class="status-tag">
              {{ scope.row.applicantStatus === 'approved' ? $t('MemberRegistrationReview.statusApproved') : $t('MemberRegistrationReview.statusRejected') }}
            </el-tag>
            <el-button 
              @click="handleView(scope.row)" 
              type="info" 
              size="small"
              class="view-btn">
              <el-icon><View /></el-icon>
              {{ $t('MemberRegistrationReview.view') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :model-value="reviewDialogVisible" :title="getDialogTitle()" width="700px" :show-close="true" @close="closeReviewDialog">
      <el-form :model="reviewForm" :rules="reviewRules" ref="reviewFormRef" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.contactName')">
              <el-input v-model="currentApplication.contactName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.storeName')">
              <el-input v-model="currentApplication.storeName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.email')">
              <el-input v-model="currentApplication.email" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.tel')">
              <el-input v-model="currentApplication.tel" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.country')">
              <el-input v-model="currentApplication.country" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.location')">
              <el-input v-model="currentApplication.location" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.postCode')">
              <el-input v-model="currentApplication.postCode" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.taxNumber')">
              <el-input v-model="currentApplication.taxNumber" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('MemberRegistrationReview.workWithAnanda')">
              <el-input :value="currentApplication.workWithAnanda === 'yes' ? $t('MemberRegistrationReview.yes') : $t('MemberRegistrationReview.no')" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.howKnowAnanda')">
              <el-input v-model="currentApplication.howKnowAnanda" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.whyChooseAnanda')">
              <el-input v-model="currentApplication.whyChooseAnanda" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.officeArea')">
              <el-input v-model="currentApplication.officeArea" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.warehouse')">
              <el-input v-model="currentApplication.warehouse" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.staff')">
              <el-input v-model="currentApplication.staff" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.applicantStatus')">
              <el-input v-model="currentApplication.statusText" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('MemberRegistrationReview.reviewResult')" prop="reviewResult">
          <el-select v-model="reviewForm.reviewResult" style="width: 100%" :disabled="reviewForm.reviewResult !== ''">
            <el-option :label="$t('MemberRegistrationReview.statusApproved')" value="approved" />
            <el-option :label="$t('MemberRegistrationReview.statusRejected')" value="rejected" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('MemberRegistrationReview.reviewComment')" prop="reviewComment">
          <el-input 
            v-model="reviewForm.reviewComment" 
            type="textarea" 
            :rows="4" 
            :placeholder="$t('MemberRegistrationReview.reviewCommentPlaceholder')"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="closeReviewDialog" type="default">{{ $t('MemberRegistrationReview.cancel') }}</el-button>
        <el-button @click="submitReview" :loading="reviewLoading" type="primary">{{ $t('MemberRegistrationReview.confirmReview') }}</el-button>
      </template>
    </el-dialog>

    <el-dialog :model-value="viewDialogVisible" :title="$t('MemberRegistrationReview.viewApplication')" width="700px" :show-close="true" @close="closeViewDialog">
      <el-form :model="currentApplication" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.contactName')">
              <el-input v-model="currentApplication.contactName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.storeName')">
              <el-input v-model="currentApplication.storeName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.email')">
              <el-input v-model="currentApplication.email" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.tel')">
              <el-input v-model="currentApplication.tel" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.country')">
              <el-input v-model="currentApplication.country" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.location')">
              <el-input v-model="currentApplication.location" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.postCode')">
              <el-input v-model="currentApplication.postCode" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.taxNumber')">
              <el-input v-model="currentApplication.taxNumber" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('MemberRegistrationReview.workWithAnanda')">
              <el-input :value="currentApplication.workWithAnanda === 'yes' ? $t('MemberRegistrationReview.yes') : $t('MemberRegistrationReview.no')" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.howKnowAnanda')">
              <el-input v-model="currentApplication.howKnowAnanda" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.whyChooseAnanda')">
              <el-input v-model="currentApplication.whyChooseAnanda" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.officeArea')">
              <el-input v-model="currentApplication.officeArea" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.warehouse')">
              <el-input v-model="currentApplication.warehouse" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.staff')">
              <el-input v-model="currentApplication.staff" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.applicantStatus')">
              <el-input v-model="currentApplication.statusText" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('MemberRegistrationReview.applyTime')">
              <el-input :value="formatDateTime(currentApplication.applyTime)" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.reviewer')">
              <el-input v-model="currentApplication.reviewer" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('MemberRegistrationReview.reviewTime')">
              <el-input :value="currentApplication.reviewTime ? formatDateTime(currentApplication.reviewTime) : '-'" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('MemberRegistrationReview.reviewComment')">
              <el-input v-model="currentApplication.reviewComment" type="textarea" :rows="3" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="closeViewDialog" type="default">{{ $t('MemberRegistrationReview.close') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import dialogMixin from '@/mixins/dialogMixin';
import { passMemberApply, rejectMemberApply } from '@/api/api';

export default {
  mixins: [dialogMixin],
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      reviewDialogVisible: false,
      viewDialogVisible: false,
      currentApplication: {},
      reviewForm: {
        reviewResult: '',
        reviewComment: ''
      },
      reviewRules: {
        reviewResult: [
          { required: true, message: this.$t('MemberRegistrationReview.reviewResultRequired'), trigger: 'change' }
        ],
        reviewComment: [
          { required: true, message: this.$t('MemberRegistrationReview.reviewCommentRequired'), trigger: 'blur' },
          { min: 5, message: this.$t('MemberRegistrationReview.reviewCommentMinLength'), trigger: 'blur' }
        ]
      },
      reviewLoading: false
    };
  },
  methods: {
    getStatusType(status) {
      const typeMap = {
        'pending': 'warning',
        'approved': 'success',
        'rejected': 'danger'
      };
      return typeMap[status] || 'info';
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      const date = new Date(dateTime);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    getDialogTitle() {
      if (this.reviewForm.reviewResult === 'approved') {
        return this.$t('MemberRegistrationReview.approveApplication');
      } else if (this.reviewForm.reviewResult === 'rejected') {
        return this.$t('MemberRegistrationReview.rejectApplication');
      }
      return this.$t('MemberRegistrationReview.reviewApplication');
    },

    handleApprove(row) {
      this.currentApplication = { ...row };
      this.reviewForm = {
        reviewResult: 'approved',
        reviewComment: ''
      };
      this.reviewDialogVisible = true;
    },

    handleReject(row) {
      this.currentApplication = { ...row };
      this.reviewForm = {
        reviewResult: 'rejected',
        reviewComment: ''
      };
      this.reviewDialogVisible = true;
    },

    handleView(row) {
      this.currentApplication = { ...row };
      this.viewDialogVisible = true;
    },

    closeReviewDialog() {
      this.reviewDialogVisible = false;
      this.currentApplication = {};
      this.reviewForm = {
        reviewResult: '',
        reviewComment: ''
      };
    },

    closeViewDialog() {
      this.viewDialogVisible = false;
      this.currentApplication = {};
    },

    async submitReview() {
      try {
        if (!this.$refs.reviewFormRef) {
          ElMessage.error(this.$t('MemberRegistrationReview.formValidationError'));
          return;
        }
        
        await this.$refs.reviewFormRef.validate();
        
        this.reviewLoading = true;
        
        const applyId = this.currentApplication.id;
        const reviewComment = this.reviewForm.reviewComment;
        
        if (this.reviewForm.reviewResult === 'approved') {
          await passMemberApply(applyId, { comment: reviewComment });
        } else {
          await rejectMemberApply(applyId, { comment: reviewComment });
        }
        
        ElMessage.success(this.$t('MemberRegistrationReview.reviewSuccess'));
        this.closeReviewDialog();
        this.$emit('refresh');
        
      } catch (error) {
        if (error !== false) {
          console.error('审核失败:', error);
          if (!(error && error.message === this.$t('MemberRegistrationReview.reviewCommentMinLength'))) {
            ElMessage.error(this.$t('MemberRegistrationReview.reviewFailed'));
          }
        }
      } finally {
        this.reviewLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.table-container {
  margin: 20px;
}

.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.approve-btn {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
  border: none;
  box-shadow: 0 2px 4px rgba(103, 194, 58, 0.3);
  transition: all 0.3s ease;
}

.approve-btn:hover {
  background: linear-gradient(135deg, #5daf34 0%, #7bc85a 100%);
  box-shadow: 0 4px 8px rgba(103, 194, 58, 0.4);
  transform: translateY(-1px);
}

.reject-btn {
  background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%);
  border: none;
  box-shadow: 0 2px 4px rgba(245, 108, 108, 0.3);
  transition: all 0.3s ease;
}

.reject-btn:hover {
  background: linear-gradient(135deg, #f45656 0%, #f77777 100%);
  box-shadow: 0 4px 8px rgba(245, 108, 108, 0.4);
  transform: translateY(-1px);
}

.status-display {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}

.status-tag {
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 12px;
}

.view-btn {
  background: linear-gradient(135deg, #909399 0%, #a6a9ad 100%);
  border: none;
  box-shadow: 0 2px 4px rgba(144, 147, 153, 0.3);
  transition: all 0.3s ease;
}

.view-btn:hover {
  background: linear-gradient(135deg, #82848a 0%, #9ca0a4 100%);
  box-shadow: 0 4px 8px rgba(144, 147, 153, 0.4);
  transform: translateY(-1px);
}

.el-button {
  border-radius: 6px;
  font-weight: 500;
}

.el-button .el-icon {
  margin-right: 4px;
}
</style>